var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 58,
    viewBox: "0 0 198 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "googleplay"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M189.919 57.686H8.08101C4.0824 57.686 0.807495 54.4886 0.807495 50.5846V7.97594C0.807495 4.07193 4.0824 0.8745 8.08101 0.8745H189.919C193.918 0.8745 197.193 4.07193 197.193 7.97594V50.5846C197.193 54.4886 193.918 57.686 189.919 57.686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M189.919 2.0125C193.287 2.0125 196.027 4.68797 196.027 7.97594V50.5846C196.027 53.8726 193.287 56.548 189.919 56.548H8.08101C4.71337 56.548 1.97308 53.8726 1.97308 50.5846V7.97594C1.97308 4.68797 4.71337 2.0125 8.08101 2.0125H189.919ZM189.919 0.8745H8.08101C4.0824 0.8745 0.807495 4.07193 0.807495 7.97594V50.5846C0.807495 54.4886 4.0824 57.686 8.08101 57.686H189.919C193.918 57.686 197.193 54.4886 197.193 50.5846V7.97594C197.193 4.07193 193.918 0.8745 189.919 0.8745Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "M69.7859 15.4238C69.7859 16.6097 69.4222 17.5596 68.7058 18.2679C67.8821 19.1077 66.8092 19.5302 65.4945 19.5302C64.238 19.5302 63.1652 19.1006 62.2851 18.2537C61.4032 17.3945 60.9631 16.3399 60.9631 15.0776C60.9631 13.8153 61.4032 12.7608 62.2851 11.9086C63.1652 11.0546 64.238 10.625 65.4945 10.625C66.1201 10.625 66.7165 10.7511 67.2856 10.9854C67.853 11.2215 68.3148 11.5411 68.6494 11.9352L67.8893 12.6844C67.3056 12.0116 66.511 11.6796 65.4945 11.6796C64.5781 11.6796 63.7834 11.992 63.1088 12.6223C62.4415 13.2543 62.1069 14.0728 62.1069 15.0776C62.1069 16.0825 62.4415 16.908 63.1088 17.54C63.7834 18.1632 64.5781 18.4827 65.4945 18.4827C66.4674 18.4827 67.2856 18.1632 67.9312 17.5329C68.3567 17.1157 68.5985 16.5405 68.6621 15.8055H65.4945V14.7793H69.7204C69.7713 15.0013 69.7859 15.2161 69.7859 15.4238Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "M76.4902 11.8658H72.5207V14.5643H76.0993V15.5905H72.5207V18.289H76.4902V19.3347H71.3969V10.8201H76.4902V11.8658Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "M81.2216 19.3347H80.0979V11.8658H77.6631V10.8201H83.6583V11.8658H81.2216V19.3347Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "M87.997 19.3347V10.8201H89.1189V19.3347H87.997Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "M94.0921 19.3347H92.9775V11.8658H90.5336V10.8201H96.536V11.8658H94.0921V19.3347Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "M107.886 18.2395C107.026 19.1006 105.961 19.5302 104.69 19.5302C103.411 19.5302 102.346 19.1006 101.486 18.2395C100.627 17.3802 100.2 16.3257 100.2 15.0776C100.2 13.8295 100.627 12.775 101.486 11.9157C102.346 11.0546 103.411 10.625 104.69 10.625C105.953 10.625 107.019 11.0546 107.879 11.9228C108.745 12.7892 109.172 13.8366 109.172 15.0776C109.172 16.3257 108.745 17.3802 107.886 18.2395ZM102.317 17.5258C102.964 18.1632 103.751 18.4827 104.69 18.4827C105.621 18.4827 106.415 18.1632 107.055 17.5258C107.701 16.8885 108.028 16.07 108.028 15.0776C108.028 14.0852 107.701 13.2667 107.055 12.6294C106.415 11.992 105.621 11.6725 104.69 11.6725C103.751 11.6725 102.964 11.992 102.317 12.6294C101.671 13.2667 101.344 14.0852 101.344 15.0776C101.344 16.07 101.671 16.8885 102.317 17.5258Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "M110.748 19.3347V10.8201H112.112L116.353 17.4422H116.402L116.353 15.8053V10.8201H117.475V19.3347H116.304L111.863 12.3859H111.814L111.863 14.0299V19.3347H110.748Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "M99.9237 31.7696C96.5069 31.7696 93.7157 34.3084 93.7157 37.8112C93.7157 41.2855 96.5069 43.8509 99.9237 43.8509C103.348 43.8509 106.139 41.2855 106.139 37.8112C106.139 34.3084 103.348 31.7696 99.9237 31.7696ZM99.9237 41.472C98.0489 41.472 96.436 39.9611 96.436 37.8112C96.436 35.6328 98.0489 34.1486 99.9237 34.1486C101.798 34.1486 103.419 35.6328 103.419 37.8112C103.419 39.9611 101.798 41.472 99.9237 41.472ZM86.3786 31.7696C82.9545 31.7696 80.1706 34.3084 80.1706 37.8112C80.1706 41.2855 82.9545 43.8509 86.3786 43.8509C89.8007 43.8509 92.5865 41.2855 92.5865 37.8112C92.5865 34.3084 89.8007 31.7696 86.3786 31.7696ZM86.3786 41.472C84.502 41.472 82.8836 39.9611 82.8836 37.8112C82.8836 35.6328 84.502 34.1486 86.3786 34.1486C88.2533 34.1486 89.8662 35.6328 89.8662 37.8112C89.8662 39.9611 88.2533 41.472 86.3786 41.472ZM70.2604 33.6213V36.1885H76.5393C76.3556 37.623 75.8647 38.6775 75.1119 39.4125C74.1954 40.3002 72.768 41.2855 70.2604 41.2855C66.3964 41.2855 63.3706 38.2408 63.3706 34.4682C63.3706 30.6955 66.3964 27.6508 70.2604 27.6508C72.3498 27.6508 73.8699 28.4479 74.9919 29.4812L76.8448 27.6721C75.2755 26.2092 73.188 25.0854 70.2604 25.0854C64.9617 25.0854 60.5085 29.2948 60.5085 34.4682C60.5085 39.6416 64.9617 43.8509 70.2604 43.8509C73.1244 43.8509 75.2755 42.9349 76.9666 41.2163C78.6995 39.5244 79.2396 37.1454 79.2396 35.2245C79.2396 34.6279 79.1887 34.0794 79.0978 33.6213H70.2604ZM136.169 35.6115C135.658 34.2604 134.082 31.7696 130.871 31.7696C127.688 31.7696 125.039 34.2178 125.039 37.8112C125.039 41.195 127.661 43.8509 131.176 43.8509C134.018 43.8509 135.658 42.159 136.333 41.1737L134.224 39.8013C133.52 40.8062 132.562 41.472 131.176 41.472C129.8 41.472 128.812 40.8559 128.179 39.6416L136.455 36.2986L136.169 35.6115ZM127.732 37.623C127.661 35.2937 129.585 34.1007 130.963 34.1007C132.044 34.1007 132.96 34.6279 133.265 35.3825L127.732 37.623ZM121.006 43.4834H123.726V25.7299H121.006V43.4834ZM116.551 33.1153H116.46C115.849 32.4088 114.683 31.7696 113.207 31.7696C110.108 31.7696 107.275 34.4256 107.275 37.8307C107.275 41.2163 110.108 43.8509 113.207 43.8509C114.683 43.8509 115.849 43.2065 116.46 42.4786H116.551V43.345C116.551 45.6547 115.287 46.8957 113.249 46.8957C111.587 46.8957 110.556 45.7239 110.13 44.7386L107.765 45.7026C108.446 47.304 110.252 49.2747 113.249 49.2747C116.438 49.2747 119.129 47.4425 119.129 42.9846V32.1371H116.551V33.1153ZM113.44 41.472C111.565 41.472 109.996 39.9398 109.996 37.8307C109.996 35.702 111.565 34.1486 113.44 34.1486C115.287 34.1486 116.744 35.702 116.744 37.8307C116.744 39.9398 115.287 41.472 113.44 41.472ZM148.905 25.7299H142.399V43.4834H145.112V36.7566H148.905C151.918 36.7566 154.873 34.6279 154.873 31.2423C154.873 27.8585 151.911 25.7299 148.905 25.7299ZM148.976 34.2871H145.112V28.1994H148.976C151.002 28.1994 152.158 29.8416 152.158 31.2423C152.158 32.6165 151.002 34.2871 148.976 34.2871ZM165.747 31.7359C163.787 31.7359 161.749 32.581 160.91 34.454L163.318 35.4393C163.836 34.454 164.789 34.1344 165.796 34.1344C167.204 34.1344 168.631 34.9599 168.653 36.4175V36.6039C168.162 36.327 167.111 35.9169 165.818 35.9169C163.225 35.9169 160.583 37.3105 160.583 39.9114C160.583 42.2904 162.707 43.8225 165.094 43.8225C166.92 43.8225 167.927 43.0183 168.56 42.0827H168.653V43.455H171.273V36.6448C171.273 33.497 168.866 31.7359 165.747 31.7359ZM165.42 41.4649C164.532 41.4649 163.296 41.0352 163.296 39.9611C163.296 38.587 164.838 38.0597 166.173 38.0597C167.367 38.0597 167.927 38.3171 168.653 38.6562C168.44 40.3002 166.991 41.4649 165.42 41.4649ZM180.82 32.1247L177.701 39.8209H177.608L174.384 32.1247H171.459L176.303 42.8798L173.539 48.8646H176.374L183.838 32.1247H180.82ZM156.364 43.4834H159.085V25.7299H156.364V43.4834Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path64",
    d: "M15.9874 11.5819C15.56 12.0187 15.3127 12.6986 15.3127 13.5792V44.9889C15.3127 45.8695 15.56 46.5494 15.9874 46.9862L16.0928 47.082L34.1202 29.4882V29.0728L16.0928 11.4789L15.9874 11.5819Z",
    fill: "url(#paint0_linear_666_5141)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path78",
    d: "M40.1227 35.3557L34.1202 29.4881V29.0727L40.1299 23.2051L40.2645 23.2815L47.3816 27.2352C49.4128 28.3572 49.4128 30.2036 47.3816 31.3327L40.2645 35.2794L40.1227 35.3557Z",
    fill: "url(#paint1_linear_666_5141)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path88",
    d: "M40.2645 35.279L34.1202 29.28L15.9873 46.9857C16.6619 47.6781 17.762 47.7615 19.0131 47.0691L40.2645 35.279Z",
    fill: "url(#paint2_linear_666_5141)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path104",
    d: "M40.2645 23.2813L19.0131 11.4912C17.762 10.8059 16.6619 10.8893 15.9873 11.5817L34.1202 29.2803L40.2645 23.2813Z",
    fill: "url(#paint3_linear_666_5141)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_666_5141",
    x1: 32.5196,
    y1: 45.316,
    x2: 8.69059,
    y2: 20.9096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_666_5141",
    x1: 50.0265,
    y1: 29.2784,
    x2: 14.8272,
    y2: 29.2784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_666_5141",
    x1: 36.9234,
    y1: 26.0189,
    x2: 4.6093,
    y2: -7.07823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_666_5141",
    x1: 11.4229,
    y1: 57.4358,
    x2: 25.8526,
    y2: 42.6566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.af6d31cfb149123ce743c337b3a00739.svg";
export { ForwardRef as ReactComponent };